import isUndefined from 'lodash/isUndefined';

import { SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE } from '@eventbrite/social-login-facebook';
import { parseFormPostData } from '../api/utils';
import { socialLogIn as socialLogInApi } from '../api';

import {
    LOOKUP_SOCIAL_USER_EXISTENT,
    LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT,
    LOOKUP_SOCIAL_USER_EXISTENT_IN_FACEBOOK_SOFT_ACCOUNT,
    LOOKUP_SOCIAL_USER_EXISTENT_IN_GOOGLE_SOFT_ACCOUNT,
    EXTERNAL_UNKNOWN_ERROR,
} from '../constants';

import { GA_APPLE, TOSMODAL_SOCIAL_SHOWED } from '../constants/analytics';

import {
    trackLoginSuccessful,
    trackLoginSuccessOneStep,
    trackAccountAutolinked,
    trackSocialAccountCreated,
} from './gaTracking';

import { getSocialLogInFormData } from './utils';

import { handleLoginSuccess, setSocialDataAction } from './social';

import { lookupUser } from './lookup';
import { showToS, setTosSocialStatus } from './tos';

import { handleOnError, setAccountExistent } from './auth';

import {
    HeapTrackingLibrary,
    LOGIN_METHOD_APPLE,
    HEAP_ACCOUNT_LINKING_SUCCESS,
} from '@eventbrite/auth-lib/';

import { logEvent } from '@eventbrite/statsig';

// This Function canot be tested due to the return being a dispatch
// TODO: Investigate a way to test this function
//Response after complete Apple credentials to login
export const handleAppleLoginAttempt = ({ data, getState, dispatch }) => {
    const {
        social: { socialProvider },
    } = getState();
    const _data = getSocialLoginApiData({
        socialProvider,
        data,
    });
    const { email, sub } = data;

    dispatch(
        setSocialDataAction(_data, SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE),
    );
    return dispatch(lookupUser({ email: email, sub })).catch(
        ({ message } = {}) => {
            if (message === LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT) {
                // Here we need to display ToS Modal
                dispatch(setTosSocialStatus(message));
                dispatch(
                    showToS({
                        actionName: TOSMODAL_SOCIAL_SHOWED,
                    }),
                );
            } else {
                if (
                    message === LOOKUP_SOCIAL_USER_EXISTENT ||
                    message === LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT ||
                    message ===
                        LOOKUP_SOCIAL_USER_EXISTENT_IN_FACEBOOK_SOFT_ACCOUNT ||
                    message ===
                        LOOKUP_SOCIAL_USER_EXISTENT_IN_GOOGLE_SOFT_ACCOUNT
                ) {
                    return handleAppleSocialLogin({
                        data: _data,
                        getState,
                        dispatch,
                        isSoftAccount:
                            message ===
                            LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT
                                ? true
                                : false,
                    });
                } else if (isUndefined(message)) {
                    handleOnError(dispatch)({
                        errors: { type: EXTERNAL_UNKNOWN_ERROR },
                    });
                }
            }
        },
    );
};

export const handleAppleSocialLogin = ({
    data,
    getState,
    dispatch,
    isSoftAccount = false,
}) => {
    const state = getState();

    return socialLogInApi(
        parseFormPostData(getSocialLogInFormData(data, getState)),
    )
        .then((response) => {
            if (response['is_account_autolinked'] === true) {
                if (isSoftAccount) {
                    trackAccountAutolinked({
                        state,
                        sourceProvider: GA_APPLE,
                        extraInfo: '_SoftAccount',
                    });
                } else {
                    trackAccountAutolinked({
                        state,
                        sourceProvider: GA_APPLE,
                        extraInfo: '_HardAccount',
                    });
                }
                HeapTrackingLibrary.trackAccountLinkingUnlinkingHeap({
                    eventName: HEAP_ACCOUNT_LINKING_SUCCESS,
                    linkingType: 'auto-link',
                    socialMethod: GA_APPLE,
                });
                trackLoginSuccessful({
                    sourceProvider: GA_APPLE,
                    state,
                });

                HeapTrackingLibrary.trackLoginSuccessInHeap({
                    loginMethod: LOGIN_METHOD_APPLE,
                });
            } else {
                trackAppleLoginSuccess(state, response);
            }

            return handleAppleLoginSuccess({
                state,
                data,
                response,
                dispatch,
            });
        })
        .catch(handleOnError(dispatch, state, data));
};

export const trackAppleLoginSuccess = (state, response, actionCategory) => {
    if (response['new_user']) {
        trackSocialAccountCreated({ state, socialProvider: GA_APPLE });
        trackLoginSuccessful({
            sourceProvider: GA_APPLE,
            state,
        });
        HeapTrackingLibrary.trackLoginSuccessInHeap({
            loginMethod: LOGIN_METHOD_APPLE,
        });
    } else {
        trackLoginSuccessOneStep({
            sourceProvider: GA_APPLE,
            state,
            gaCategory: actionCategory,
        });
    }
};

const handleAppleLoginSuccess = ({ state, response, data, dispatch }) => {
    // Fresh account coming from the social provider
    // Scenario: appleFreshAccount, appleFreshAccount_AddingExistingAccount, appleFreshAccount_AddingSoftAccount
    dispatch(setAccountExistent(data.email));
    // Already done in: handleAppleLoginAttempt ?
    dispatch(
        setSocialDataAction(data, SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE),
    );

    handleLoginSuccess({ state, response, dispatch });
};

/**
 * Returns a useful data structure for the socialLogin api
 * @param {string} socialProvider
 * @param {object} data
 */
export const getSocialLoginApiData = ({ socialProvider, data = {} }) => {
    const _data = {
        ...data,
        sourceProvider: socialProvider,
    };

    return _data;
};
